<template>
    <div v-if="typeInput" class="input-kintone">
        <InputText :readonly="disabled" v-if="typeInput === TYPE_TEXT && !lookup" v-model="valueInput"> </InputText>
        <template v-if="typeInput === TYPE_CALC && ['NUMBER', 'NUMBER_DIGIT'].includes(formatCalc)">
            <div class="input-group-kintone" v-if="unit">
                <InputNumber readonly v-model="valueInput"></InputNumber>
                <Button class="btn bg-dark" disabled>{{ unit }}</Button>
            </div>
            <InputNumber v-else readonly v-model="valueInput"></InputNumber>
        </template>
        <el-date-picker
            readonly
            v-if="typeInput === TYPE_CALC && [TYPE_DATE, TYPE_DATE_TIME].includes(formatCalc)"
            v-model="valueInput"
            :type="formatCalc === TYPE_DATE_TIME ? 'datetime' : 'date'"
            :format="formatCalc === TYPE_DATE_TIME ? 'yyyy/MM/dd HH:mm' : 'yyyy/MM/dd (dddd)'"
        ></el-date-picker>
        <InputText :classes="{ 'text-read-only': typeInput === TYPE_FILE }" v-if="typeInput === TYPE_RECORD_NUMBER || typeInput === TYPE_FILE" v-model="valueInput" readonly> </InputText>
        <el-date-picker
            :readonly="disabled"
            v-if="[TYPE_DATE, TYPE_DATE_TIME].includes(typeInput)"
            v-model="valueInput"
            :type="typeInput === TYPE_DATE_TIME ? 'datetime' : 'date'"
            :format="typeInput === TYPE_DATE_TIME ? 'yyyy/MM/dd HH:mm' : 'yyyy/MM/dd (dddd)'"
        ></el-date-picker>
        <el-time-select
            :readonly="disabled"
            :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30'
            }"
            v-if="typeInput === TYPE_TIME"
            v-model="valueInput"
        >
        </el-time-select>
        <div class="box-roles-user" :class="{ 'box-roles-user__disabled': disabled }" v-if="typeInput === TYPE_CHECK_BOX">
            <label class="ckbox mb-0 label-small" v-for="option in options" :key="option.value">
                <input :disabled="disabled" v-model="valueInput" type="checkbox" :id="'checkbox' + option.value" :value="option.value" />
                <span>{{ option.label }}</span>
            </label>
        </div>
        <template v-if="typeInput === 'NUMBER'">
            <div class="input-group-kintone" v-if="unit">
                <InputNumber :readonly="disabled" v-model="valueInput"> </InputNumber>
                <Button class="btn bg-dark" disabled>{{ unit }}</Button>
            </div>
            <InputNumber v-else :readonly="disabled" v-model="valueInput"> </InputNumber>
        </template>
        <SelectCustom classes="w-100" :disabled="disabled" :loading="isLoadingOption" v-if="lookup" @visible-change="onGetDataOptions" v-model="valueInput">
            <template #options>
                <el-option v-for="option in optionsLockup" :key="option" :value="option" :lable="option">
                    {{ option }}
                </el-option>
            </template>
        </SelectCustom>
        <SelectCustom classes="w-100" :disabled="disabled" v-if="typeInput === TYPE_DROPDOWN" v-model="valueInput">
            <template #options>
                <el-option v-for="option in options" :key="option" :value="option" :lable="option">
                    {{ option }}
                </el-option>
            </template>
        </SelectCustom>
        <SelectCustom
            classes="w-100"
            :disabled="disabled"
            :is-multi="TYPE_ORGANIZATION_SELECT === typeInput"
            v-if="[TYPE_GROUP_SELECT, TYPE_ORGANIZATION_SELECT, TYPE_USER_SELECT].includes(typeInput)"
            v-model="valueInput"
        >
            <template #options>
                <el-option v-for="option in dataOptions" :key="option" :value="option" :lable="option">
                    {{ option }}
                </el-option>
            </template>
        </SelectCustom>
        <SelectCustom classes="w-100" :disabled="disabled" v-if="typeInput === TYPE_MULTI_SELECT" is-multi default-first :collapse-tags="collapseTagsSelect" v-model="valueInput">
            <template #options>
                <el-option v-for="option in options" :key="option" :value="option" :lable="option">
                    {{ option }}
                </el-option>
            </template>
        </SelectCustom>
        <RadioList v-if="typeInput === TYPE_RADIO_BUTTON" v-model="valueInput" :disabled="disabled" is-text :data-list="options"> </RadioList>
        <vue-editor v-if="typeInput === TYPE_RICK_TEXT" :disabled="disabled" v-model="valueInput"></vue-editor>
        <InputText v-if="typeInput === TYPE_LINK && protocolLink !== 'CALL' && protocolLink !== 'WEB'" v-model="valueInput" :disabled="disabled"></InputText>
        <template v-if="typeInput === TYPE_LINK && protocolLink === 'WEB'">
            <div class="input-group-kintone">
                <InputText classes="field-web" v-model="valueInput" :disabled="disabled"></InputText>
                <Button class="btn bg-primary" @click="openLink(valueInput)" :disabled="!valueInput"><el-icon class="el-icon-top-right cursor-pointer"></el-icon></Button>
            </div>
        </template>
        <InputText v-if="typeInput === TYPE_LINK && protocolLink === 'CALL'" v-model="valueInput" @keypress="onValidPhoneNumber" @paste="onPasteValidPhoneNumber" :disabled="disabled"></InputText>
        <InputText
            v-if="
                ![
                    TYPE_GROUP_SELECT,
                    TYPE_LINK,
                    TYPE_TEXTS,
                    TYPE_ORGANIZATION_SELECT,
                    TYPE_USER_SELECT,
                    TYPE_RECORD_NUMBER,
                    TYPE_RICK_TEXT,
                    TYPE_MULTI_SELECT,
                    TYPE_RADIO_BUTTON,
                    TYPE_DROPDOWN,
                    TYPE_NUMBER,
                    TYPE_CHECK_BOX,
                    TYPE_DATE_TIME,
                    TYPE_TEXT,
                    TYPE_CALC,
                    TYPE_DATE,
                    TYPE_TIME,
                    TYPE_FILE
                ].includes(typeInput)
            "
            v-model="valueInput"
            :disabled="disabled"
            :data-list="options"
        ></InputText>
        <textarea :rows="3" :readonly="disabled" v-model="valueInput" v-if="typeInput === TYPE_TEXTS" class="form-control"></textarea>
        <div class="text-note-input" v-if="typeInput === TYPE_CALC || typeInput === TYPE_FILE">
            {{ typeInput === TYPE_CALC ? $t('recordForm.autoCalculatedInputNote') : $t('recordForm.noSupportAttachment') }}
        </div>
    </div>
</template>
<script>
import {
    TYPE_TEXT,
    TYPE_RADIO_BUTTON,
    TYPE_DROPDOWN,
    TYPE_NUMBER,
    TYPE_CHECK_BOX,
    TYPE_DATE_TIME,
    TYPE_DATE,
    TYPE_TIME,
    TYPE_RECORD_NUMBER,
    TYPE_CALC,
    TYPE_FILE,
    TYPE_TEXTS,
    TYPE_LINK,
    TYPE_MULTI_SELECT,
    TYPE_RICK_TEXT,
    TYPE_USER_SELECT,
    TYPE_GROUP_SELECT,
    TYPE_ORGANIZATION_SELECT
} from '@/config/constants';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import InputNumber from '@/components/partials/customs/InputNumber';
import RadioList from '@/components/partials/RadioList';
import InputText from '@/components/partials/customs/InputText';
import { VueEditor } from 'vue2-editor';
import { validNumber } from '@/utils';

export default {
    name: 'input-kintone-setting',
    props: {
        value: {
            required: true
        },
        disabled: {
            require: false
        },
        options: {
            type: Array,
            default: function () {
                return [];
            }
        },
        typeInput: {
            require: false,
            default: TYPE_TEXT
        },
        lookup: {
            require: false,
            default: function () {
                return false;
            }
        },
        dataLocal: {
            require: false
        },
        formatCalc: {
            require: false,
            default: function () {
                return null;
            }
        },
        protocolLink: {
            default: function () {
                return 'WEB';
            },
            require: false
        },
        unit: {
            default: null,
            require: false
        }
    },
    components: {
        RadioList,
        InputNumber,
        SelectCustom,
        InputText,
        VueEditor
    },
    data() {
        return {
            valueInput: '',
            optionsLockup: [],
            TYPE_TEXT,
            TYPE_RADIO_BUTTON,
            TYPE_DROPDOWN,
            TYPE_NUMBER,
            TYPE_CHECK_BOX,
            TYPE_DATE_TIME,
            TYPE_DATE,
            TYPE_TIME,
            TYPE_RECORD_NUMBER,
            TYPE_CALC,
            TYPE_FILE,
            TYPE_TEXTS,
            TYPE_MULTI_SELECT,
            TYPE_RICK_TEXT,
            TYPE_USER_SELECT,
            TYPE_GROUP_SELECT,
            TYPE_LINK,
            TYPE_ORGANIZATION_SELECT,
            isLoadingOption: false,
            collapseTagsSelect: false
        };
    },
    model: {
        event: 'update',
        prop: 'value'
    },
    mounted() {
        if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT].includes(this.typeInput)) {
            this.valueInput = this.value || [];
        } else {
            this.valueInput = this.value || '';
        }
        if (this.$route.name === 'dataViewEditMultiple') {
            this.collapseTagsSelect = true;
        } else {
            this.collapseTagsSelect = false;
        }
    },
    computed: {
        dataOptions() {
            let result = [];
            switch (this.typeInput) {
                case TYPE_USER_SELECT: {
                    if (this.dataLocal && this.dataLocal.users) {
                        result = this.dataLocal.users;
                    }
                    break;
                }
                case TYPE_ORGANIZATION_SELECT:
                    if (this.dataLocal && this.dataLocal.departments) {
                        result = this.dataLocal.departments;
                    }
                    break;
                case TYPE_GROUP_SELECT:
                    if (this.dataLocal && this.dataLocal.groups) {
                        result = this.dataLocal.groups;
                    }
                    break;
            }
            return result;
        }
    },
    methods: {
        openLink(link) {
            window.open(link, '_blank');
        },
        onValidPhoneNumber(evt) {
            evt = evt || window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onPasteValidPhoneNumber(evt) {
            let text = evt.clipboardData.getData('text');
            if (!validNumber(text)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onGetDataOptions(isVisible) {
            if (isVisible && this.optionsLockup && this.optionsLockup.length === 0) {
                this.getOptionLookup();
            }
        },
        getOptionLookup() {
            let { lookup } = this;
            let relatedApp = lookup && lookup.relatedApp ? lookup.relatedApp.app : null;
            let relatedField = lookup && lookup.relatedKeyField ? lookup.relatedKeyField : '';
            this.isLoadingOption = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                  this.optionsLockup = response?.data?.data?.data ?? [];
                }
                this.isLoadingOption = false;
            };
            let errorCallback = () => {
                this.isLoadingOption = false;
            };

            let payload = {
                successCallback,
                errorCallback,
                appId: relatedApp,
                shareId: this.$route.query.idShare ? this.$route.query.idShare : this.$route.query.id,
                relatedField:relatedField
            };
            this.$store.dispatch('share/getAllDataAppById', payload);
        }
    },
    watch: {
        valueInput: {
            handler: function (val) {
                this.$emit('update', val);
                this.$emit('onValidate', val);
            }
        }
    }
};
</script>
